import React from "react";

export default ({ color, size }) => (
  <svg width={size || 24} height={size || 24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>arrow-top-left</title>
    <path fill={color} d="M19,17.59L17.59,19L7,8.41V15H5V5H15V7H8.41L19,17.59Z" />
  </svg>
);
